// fik.js

if ((typeof window.Fik) == 'undefined') {
  window.Fik = {};
}

Fik.ShopifyAPI = {
  getCart: async () => {
    const result = await fetch("/cart.json");
    return result.json();
  },
  updateCartAttributes: async (attributes) => {
    const result = await fetch("/cart/update.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        attributes: attributes
      })
    });

    return result.json();
  },
  fetchRates: async (countryCode, provinceCode, postalCode) => {
    const params = new URLSearchParams({
      'shipping_address[zip]': postalCode,
      'shipping_address[country]': countryCode,
      'shipping_address[province]': provinceCode,
    });

    try {
      const response = await fetch(`/cart/shipping_rates.json?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      return data.shipping_rates || [];
    } catch (error) {
      console.error("Error fetching shipping rates:", error);
      return [];
    }
  }
};

window.addEventListener("DOMContentLoaded", async () => {
  let api = Fik.ShopifyAPI;
  let cartData = await Fik.ShopifyAPI.getCart();
  let currentMarket = window.market;

  if (cartData.attributes.market != currentMarket) {
    console.log(api.updateCartAttributes({ "market": currentMarket }));
  }
});